










































import {Component, Vue, Mixins, Prop} from "vue-property-decorator";
import ConfigMixin from "../../mixins/ConfigMixin";
import {Client, ClientService} from "./../../services/accounting.service"
import PhoneDisplay from "./../ui/PhoneDisplay.vue"
import AddressDisplay from "./../ui/AddressDisplay.vue"

@Component({
    components: {
        PhoneDisplay,
        AddressDisplay,
    }
})
export default class ClientsList extends Mixins(ConfigMixin) {
    @Prop()
    clients!: Client[];
}
